export const GOOGLE_TAG_MANAGER_CONTAINER_ID = process.env.REACT_APP_GOOGLE_TAG_MANAGER_CONTAINER_ID;